import { Chat } from "sweet-global";
import {
  ADD_CHAT_MESSAGES,
  ChatActionTypes,
  ChatState,
  CREATE_CHAT_FAILURE,
  CREATE_CHAT_INIT,
  CREATE_CHAT_SUCCESS,
  DELETE_CHAT,
  GET_CHATS_FAILURE,
  GET_CHATS_INIT,
  GET_CHATS_SUCCESS,
  REMOVE_CHAT_MESSAGE,
  RESET_CHAT,
  SEND_MESSAGE_FAILURE,
  SEND_MESSAGE_INIT,
  SEND_MESSAGE_SUCCESS
} from "./types";

const initialState: ChatState = {
  chats: {},
  archivedChats: {},
  chatUsers: {},
  chatVenues: {},
  chatMessages: {},
  isGettingChats: false,
  successGettingChats: false,
  errorGettingChats: null,
  isCreatingChat: false,
  successCreatingChat: false,
  errorCreatingChat: null,
  isSendingMessage: false,
  successSendingMessage: false,
  errorSendingMessage: null
};

export default function appReducer(
  state = initialState,
  action: ChatActionTypes
) {
  switch (action.type) {
    case GET_CHATS_INIT:
      return {
        ...state,
        isGettingChats: true
      };

    case GET_CHATS_SUCCESS:
      const newState = Object.assign({}, state);
      newState.chats = action.chats;
      newState.archivedChats = action.archivedChats;
      if (action.chatUsers) newState.chatUsers = action.chatUsers;
      if (action.chatVenues) newState.chatVenues = action.chatVenues;

      return newState;

    case GET_CHATS_FAILURE:
      return {
        ...state,
        isGettingChats: false,
        successGettingChats: false,
        errorGettingChats: action.error
      };

    case CREATE_CHAT_INIT:
      return {
        ...state,
        isCreatingChat: true
      };

    case CREATE_CHAT_SUCCESS:
      return {
        ...state,
        isCreatingChat: false,
        successCreatingChat: true
      };

    case CREATE_CHAT_FAILURE:
      return {
        ...state,
        isCreatingChat: false,
        successCreatingChat: false,
        errorCreatingChat: action.error
      };

    case SEND_MESSAGE_INIT:
      return {
        ...state,
        isSendingMessage: true
      };

    case SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        isSendingMessage: false,
        successSendingMessage: true
      };

    case SEND_MESSAGE_FAILURE:
      return {
        ...state,
        isSendingMessage: false,
        successSendingMessage: false,
        errorSendingMessage: action.error
      };

    case DELETE_CHAT:
      const newChats = Object.assign({}, state.chats);
      const newChatMessages = Object.assign({}, state.chatMessages);
      delete newChats[action.chatId];
      delete newChatMessages[action.chatId];

      return {
        ...state,
        chats: newChats,
        chatMessages: newChatMessages
      };

    case ADD_CHAT_MESSAGES:
      return {
        ...state,
        chatMessages: {
          ...state.chatMessages,
          [action.chatId]: {
            ...state.chatMessages[action.chatId],
            ...action.messages
          }
        }
      };

    case REMOVE_CHAT_MESSAGE:
      const newChat = state.chatMessages[action.chatId];
      if (newChat[action.messageId]) delete newChat[action.messageId];

      return {
        ...state,
        chatMessages: {
          ...state.chatMessages,
          [action.chatId]: newChat
        }
      };

    case RESET_CHAT:
      return initialState;

    default:
      return state;
  }
}
